import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import LanguageSwitcher from './LanguageSwitcher';

const Header: React.FC = () => {
  const { t } = useTranslation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="relative border-b-[3px] border-black flex flex-col md:flex-row">
      <div className="flex-1 flex items-center justify-between p-4 md:p-6 border-b-[3px] md:border-b-0 md:border-r-[3px] border-black">
        <div className="flex items-center gap-4">
          <Link
            to="/"
            className="stamp-effect border-black text-black hover:text-[#C41E3A] transition-colors"
            onClick={() => setMobileMenuOpen(false)}
          >
            {t('header.title')}
          </Link>
          <div className="hidden lg:block bg-black text-white text-[10px] px-2 py-1 uppercase font-bold tracking-tighter">
            {t('header.mobileInfo')}
          </div>
        </div>
        <div className="flex items-center gap-4">
          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden border-2 border-black bg-white p-2 hover:bg-black hover:text-white transition-colors"
            aria-label="Toggle menu"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {mobileMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
          <span className="hidden md:inline bg-black text-white text-[10px] px-2 py-0.5 font-bold uppercase">
            {t('header.established')}
          </span>
        </div>
      </div>

      <nav className="flex-none flex items-center bg-black md:bg-transparent">
        <div className="hidden md:flex items-center px-6 gap-6 h-full">
          {/* Quick Navigation Links */}
          <Link
            to="/about"
            className="text-xs font-black uppercase tracking-tighter hover:text-[#C41E3A] transition-colors"
          >
            {t('footer.links.about')}
          </Link>
          <Link
            to="/products"
            className="text-xs font-black uppercase tracking-tighter hover:text-[#C41E3A] transition-colors"
          >
            {t('footer.links.products')}
          </Link>
          <Link
            to="/spomenik-maps"
            className="text-xs font-black uppercase tracking-tighter hover:text-[#C41E3A] transition-colors"
          >
            Spomenik Maps
          </Link>
          <Link
            to="/dossier"
            className="text-xs font-black uppercase tracking-tighter hover:text-[#C41E3A] transition-colors"
          >
            Dossier
          </Link>
          {/* Virtual Spomenik - Hidden until SMTP setup complete */}
          {/* <Link
            to="/virtual-spomenik"
            className="bg-[#C41E3A] text-white px-3 py-1.5 text-xs font-black uppercase tracking-tighter hover:bg-black transition-colors border-2 border-black"
          >
            Virtual Spomenik
          </Link> */}
          <Link
            to="/contact"
            className="text-xs font-black uppercase tracking-tighter hover:text-[#C41E3A] transition-colors"
          >
            {t('footer.links.contact')}
          </Link>

          {/* Language Switcher */}
          <LanguageSwitcher />

          <span className="border-2 border-black px-3 py-1 text-xs font-black uppercase">
            {t('header.established')}
          </span>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden absolute top-full left-0 right-0 bg-white border-b-4 border-black z-50 shadow-[8px_8px_0px_0px_rgba(0,0,0,1)]">
            <div className="flex flex-col">
              <Link
                to="/about"
                className="p-4 text-sm font-black uppercase border-b-2 border-black hover:bg-gray-100 transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                {t('footer.links.about')}
              </Link>
              <Link
                to="/products"
                className="p-4 text-sm font-black uppercase border-b-2 border-black hover:bg-gray-100 transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                {t('footer.links.products')}
              </Link>
              <Link
                to="/dossier"
                className="p-4 text-sm font-black uppercase border-b-2 border-black hover:bg-gray-100 transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                {t('footer.links.dossier')}
              </Link>
              <Link
                to="/spomenik-maps"
                className="p-4 text-sm font-black uppercase border-b-2 border-black hover:bg-gray-100 transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                {t('footer.links.spomenikMaps')}
              </Link>
              <Link
                to="/archive"
                className="p-4 text-sm font-black uppercase border-b-2 border-black hover:bg-gray-100 transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                {t('footer.links.archive')}
              </Link>
              <Link
                to="/manifesto"
                className="p-4 text-sm font-black uppercase border-b-2 border-black hover:bg-gray-100 transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                {t('footer.links.manifesto')}
              </Link>
              <Link
                to="/contact"
                className="p-4 text-sm font-black uppercase border-b-2 border-black hover:bg-gray-100 transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                {t('footer.links.contact')}
              </Link>
              <div className="p-4 border-b-2 border-black">
                <LanguageSwitcher />
              </div>
            </div>
          </div>
        )}

        {/* Mobile quick info */}
        <div className="md:hidden w-full flex text-white text-[10px] justify-between p-2 uppercase font-bold">
          <span>{t('hero.dossierActive')}</span>
          <span>{t('hero.statusVerified')}</span>
        </div>
      </nav>
    </header>
  );
};

export default Header;
